import { SVGProps } from "react";

export const WrenchScrewdriverIcon = ({
  color = "currentColor",
  size = 16,
  strokeWidth = 1,
  ...rest
}: SVGProps<SVGSVGElement> & { size?: number }) => {
  /* Render */
  const render = () => (
    <svg width={size} height={size} {...rest} fill="none" viewBox="0 0 24 24">
      <path
        fill="none"
        d="m18 16 3.5 0.5 2 2v3l-2 -2h-2v2l2 2h-3l-2 -1.5 -0.5 -4L6 8l-4 -0.5 -1.5 -2v-3l2 2h2v-2l-2 -2h3l2 2L8 6l10 10Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill="none"
        d="m6.5 12.5 -0.5 3 -2 0.5 -3.5 3.5v4h4L8 20l0.5 -2 3 -0.5 -5 -5Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill="none"
        d="m18 6 4 -1 1.5 -3L22 0.5 19 2l-1 4Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill={color}
        opacity={0.2}
        d="M19.5 19.5v2l2 2h-3l-2 -1.5 -0.5 -4L6 8l-4 -0.5 -1.5 -2v-3l2 2h2l15 15Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill={color}
        opacity={0.2}
        d="M0.5 23.5h4L8 20l0.5 -2 3 -0.5L9 15 0.5 23.5Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill={color}
        opacity={0.2}
        d="m18 5.99999 4 -1 1.5 -3 -0.7 -0.7 -4.8 4.7Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="m6.5 12.5 -0.5 3 -2 0.5 -3.5 3.5v4h4L8 20l0.5 -2 3 -0.5 -5 -5Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="m9 15 9 -9"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="m18 6 4 -1 1.5 -3L22 0.5 19 2l-1 4Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M11.5 9.5 8 6l-0.5 -3.5 -2 -2h-3l2 2v2h-2l-2 -2v3l1.5 2L6 8l3.5 3.5"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M14.5 12.5 18 16l3.5 0.5 2 2v3l-2 -2h-2v2l2 2h-3l-2 -1.5 -0.5 -4 -3.5 -3.5"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M6 15.5 8.5 18"
        strokeWidth={strokeWidth}
      ></path>
    </svg>
  );
  return render();
};
